
export const REJECT_ORDER= 'REJECT_ORDER'
export const REJECT_ORDER_SUCCESS= 'REJECT_ORDER_SUCCESS'
export const REJECT_ORDER_ERROR='REJECT_ORDER_ERROR'


export const RejectOrder= (data) => ({
    type: REJECT_ORDER,
    payload: data
});